var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dd-background "},[(_vm.backgroundIcon)?_c('i',{class:("fas fa-" + _vm.backgroundIcon + " fa-2 bg-icon secondary--text animated zoomIn")}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }